// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__qqk28"};